import Tag from '@cobliteam/ui/components/Tag';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import type React from 'react';
import { Link } from 'react-router-dom';

import type { ProcessedStop, ProcessedStopRouteStep } from '../../store';

interface IdleEngineAlertProps {
  stop: ProcessedStop | ProcessedStopRouteStep;
  idleTimeHighlighted: boolean | undefined;
  children?: React.ReactNode;
}

const IdleEngineContent = ({ stop, idleTimeHighlighted, children }: IdleEngineAlertProps) => {
  if (stop.hasFilteredIdleOnTime) {
    const link = 'https://suporte.cobli.co/calibracao-motor-ocioso';
    const hintText = 'Os dados gerados no período de calibração são descartados. Clique para saber mais.';
    const tagText = 'Período de calibração';

    return (
      <Tooltip content={hintText} position='top'>
        <Link to={link} target='_blank'>
          <Tag size='sm' label={tagText} icon={<Icon name='rectangle-ellipsis' />} variant='contained' />
        </Link>
      </Tooltip>
    );
  }

  if (idleTimeHighlighted) {
    return (
      <div className='flex items-center gap-1.5'>
        <Icon name='triangle-alert' size='sm' color='warning' />
        <Typography variant='caption-bold' className='text-warning'>
          {children}
        </Typography>
      </div>
    );
  }

  return (
    <Typography variant='caption-default' className='text-gray-dark'>
      {children}
    </Typography>
  );
};

export default IdleEngineContent;
